import { useEffect, useState, useRef } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const POLL_MS = 15000;

/**
 * Shared notifications hook. Returns the current unread payload plus derived counts.
 * Kept identical wire format across NotificationBell and the Navbar badge so both stay in sync.
 * Backend endpoint: GET /api/notifications
 */
export default function useNotifications() {
    const [data, setData] = useState({ total: 0, messages: [], events: [], pending_requests: [] });
    const timerRef = useRef(null);

    const load = async () => {
        try {
            const res = await axios.get(`${API_URL}/api/notifications`, { withCredentials: true });
            setData(res.data || { total: 0, messages: [], events: [], pending_requests: [] });
        } catch (err) {
            // silent — not authenticated
        }
    };

    useEffect(() => {
        load();
        timerRef.current = setInterval(load, POLL_MS);
        const onFocus = () => load();
        window.addEventListener('focus', onFocus);
        window.addEventListener('m4l:notifications-refresh', onFocus);
        return () => {
            clearInterval(timerRef.current);
            window.removeEventListener('focus', onFocus);
            window.removeEventListener('m4l:notifications-refresh', onFocus);
        };
    }, []);

    const messageCount = data.unread_messages ?? (data.messages || []).filter(m => m.unread).length;
    const requestCount = (data.pending_requests || []).length;
    const acceptedCount = (data.accepted || []).filter(a => a.unread).length;
    const connectionsCount = messageCount + requestCount + acceptedCount; // Anything the /connections page can act on

    return { data, load, messageCount, requestCount, connectionsCount };
}
